<template>
  <!-- Meetups.vue -->
  <div>
    <div class="container">
      <v-layout>
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular
            indeterminate
            class="primary--text"
            :width="7"
            :size="70"
            v-if="loading"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
      <div
        class="row"
        style="margin-right: 0px; margin-left: 0px"
        v-if="!loading"
      >
        <div class="col-md-4" v-for="blog in blogs" :key="blog.id">
          <div class="">
            <div
              class="card blog-item mx-auto mb-3"
              
              @click="onLoadBlog(blog.id)"
            >
              <div class="backgroundEffect"></div>
              <div class="pic">
                <img class="" :src="blog.imageUrl" />
                <div class="date" style="font-size: 10px; font-weight: bold">
                  {{ fixDate(blog.date) }}
                </div>
              </div>
              <div class="content">
                <p class="h-1 mt-4" style="font-weight: bold">
                  {{ blog.title }}
                </p>
                <p class="text-muted mt-3">
                  {{ blog.description | fixDescription }}
                </p>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-3
                    pb-3
                  "
                >
                  <div class="btn btn-primary">Read More</div>
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      foot
                    "
                  >
                    <p class="admin">Admin</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    blogs() {
      return this.$store.getters.featuredBlogs;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  filters: {
    fixDescription: function (value) {
      const findDot = value.indexOf(".");
      var result = "";
      if (findDot === -1) {
        result = value;
      } else {
        result = value.substr(0, findDot + 1);
      }
      return result;
    },
  },
  methods: {
    onLoadBlog(id) {
      this.$router.push("/blogs/" + id);
    },
    fixDate(date) {
      const fixedDate = new Date(date);
      return (
        fixedDate.toLocaleDateString("sr") +
        " " +
        fixedDate.toLocaleTimeString("sr", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    },
  },
  components: {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

* {
  padding: 0;

  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

body {
  margin-top: 30px;
  background-color: #eee;
}

.container {
  min-height: 100vh;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0px;
}
.layout {
  flex: none;
}
.card {
  width: 280px;
  height: 520px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: #fff;
  transition: all 0.5s ease;
  cursor: pointer;
  user-select: none;
  z-index: 10;
  overflow: hidden;
}

.card .backgroundEffect {
  bottom: 0;
  height: 0px;
  width: 100%;
}

.card:hover {
  color: #fff;
  transform: scale(1.025);
  box-shadow: rgba(0, 0, 0, 0.24) 0px 5px 10px;
}

.card:hover .backgroundEffect {
  bottom: 0;
  height: 320px;
  width: 100%;
  position: absolute;
  z-index: -1;
  background: #ffd700;
  animation: popBackground 0.3s ease-in;
}

@keyframes popBackground {
  0% {
    height: 20px;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
  }

  50% {
    height: 80px;
    border-top-left-radius: 75%;
    border-top-right-radius: 75%;
  }

  75% {
    height: 160px;
    border-top-left-radius: 85%;
    border-top-right-radius: 85%;
  }

  100% {
    height: 320px;
    border-top-left-radius: 100%;
    border-top-right-radius: 100%;
  }
}

.card .pic {
  position: relative;
}

.card .pic img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.card .date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 70px;
  background-color: #ffd700;
  color: white;
  position: absolute;
  bottom: 0px;
  transition: all ease;
}

.card .date .day {
  font-size: 14px;
  font-weight: 600;
}

.card .date .month,
.card .date .year {
  font-size: 10px;
}

.card .text-muted {
  font-size: 12px;
}

.card:hover .text-muted {
  color: #fff !important;
}

.card .content {
  padding: 0 20px;
}

.card .content .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background-color: #ffd700;
  border-radius: 25px;
  font-size: 12px;
  border: none;
}

.card:hover .content .btn {
  background: #fff;
  color: #ffd700;
  box-shadow: #0000001a 0px 3px 5px;
}

.card .content .btn .fas {
  font-size: 10px;
  padding-left: 5px;
}

.card .content .foot .admin {
  color: #ffd700;
  font-size: 12px;
}

.card:hover .content .foot .admin {
  color: #fff;
}

.card .content .foot .icon {
  font-size: 12px;
}
</style>
